<template>
  <div>
    <div
      class="alert alert-custom alert-light-danger d-flex align-items-right"
      role="alert"
    >
      <div>
         مسئولیت استفاده خدمات تکیه جهت انجام پخش زنده در دیگر پلتفرم‌ها، اعم از خارجی یا داخلی، بر عهده کاربر بوده و پلتفرم تکیه در قبال خسارت‌های احتمالی از جمله محدودیت یا بسته شدن اکانت در پلتفرم مقصد، مسئولیتی بر عهده نخواهد داشت.
      </div>
    </div>

    <div class="row">
      <div
        :class="`col-sm-${item.width}`"
        v-for="(item, index) in bannersList"
        :key="index"
      >
        <picture class="w-100">
          <source media="(max-width:576px)" :srcset="item['xs']" />
          <source
            media="(min-width:576px)"
            :srcset="item['sm'] ? item['sm'] : item['xs']"
          />
          <source
            media="(min-width:768px)"
            :srcset="item['md'] ? item['md'] : item['xs']"
          />
          <source
            media="(min-width:992px)"
            :srcset="item['lg'] ? item['lg'] : item['xs']"
          />
          <source
            media="(min-width:1200px)"
            :srcset="item['xl'] ? item['xl'] : item['xs']"
          />
          <img
            :src="item['xs']"
            alt=""
            class="d-block img-fluid w-100 gutter-b"
          />
        </picture>
      </div>
    </div>

    <!--    <div>-->
    <!--      <VueIdentifyNetwork></VueIdentifyNetwork>-->
    <!--    </div>-->

    <div class="row">
      <div
        v-for="comp in infoComps"
        :key="`comp-${comp.title + comp.subtitle}`"
        class="col-xl-3"
      >
        <b-overlay :show="!comp.loaded" opacity="0.1">
          <CountInfo
            :title="comp.title"
            :subtitle="comp.subtitle"
            :background="comp.background"
            :loaded="comp.loaded"
            :dir="comp.dir"
            :bodyClass="comp.bodyClass"
            :titleClass="comp.titleClass"
            :subtitleClass="comp.subtitleClass"
          ></CountInfo>
        </b-overlay>
      </div>
    </div>
    <div class="row gutter-b">
      <div class="col-md-3">
        <b-overlay :show="!destinationsLoaded" opacity="0.1" class="h-100">
          <DestinationsWidget :destinations="destinations"></DestinationsWidget>
        </b-overlay>
      </div>
      <div class="col-md-3">
        <b-overlay :show="!programsLoaded" opacity="0.1" class="h-100">
          <ProgramsWidget :programs="programs"></ProgramsWidget>
        </b-overlay>
      </div>
      <div class="col-md-6">
        <ActiveLives :programs="programs"></ActiveLives>
      </div>
      <div class="col-md-6">
        <div id="5900863306">
          <script type="text/JavaScript" :src="videoSrc"></script>
        </div>
      </div>
      <div class="col-md-6">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          class="gutter-b"
          controls
          indicators
          background="#ffffff"
          img-width="1024"
          img-height="580"
          style="text-align: center"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide caption="" img-blank>
            <b-card
              title="مقایسه نرم افزار های vmix و obs"
              class="text-center text-dark"
              style="border: none"
              align="center"
            >
              <b-card-text>
                دوربین ها یک سیگنال ویدئویی خام تولید می کنند که برای پخش از
                طریق وب باید کدگذاری شوند. نرم افزار پخش زنده وظیفه تغییر کد
                گذاری را بر عهده دارند.
              </b-card-text>
              <b-button
                href="https://blog.mirol.ir/5/post"
                variant="primary"
                target="_blank"
                >ادامه
              </b-button>
            </b-card>
          </b-carousel-slide>
          <b-carousel-slide caption="" img-blank>
            <b-card
              title="بهترین نرم افزار های پخش زنده"
              class="text-center text-dark"
              style="border: none"
              align="center"
            >
              <b-card-text>
                امروزه می‌توانید بر روی هر سیستم عامل و یا هر پلتفرمی پخش زنده
                داشته باشید . از ویندوز که یکی از بهترین و اصلی‌ترین
                سیستم‌عامل‌ها برای‌ این کار است.
              </b-card-text>
              <b-button
                href="https://blog.mirol.ir/4/post"
                variant="primary"
                target="_blank"
                >ادامه
              </b-button>
            </b-card>
          </b-carousel-slide>
        </b-carousel>
      </div>
      <div class="col-md-6">
        <DownloadAppsWidget></DownloadAppsWidget>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import CountInfo from "@/view/content/widgets/stats/CountInfo.vue";
import DestinationsWidget from "@/view/content/widgets/list/Destinations.vue";
import ProgramsWidget from "@/view/content/widgets/list/Programs.vue";
import DownloadAppsWidget from "@/view/content/widgets/list/DownloadApps.vue";
import ActiveLives from "@/view/content/widgets/stats/ActiveLives.vue";
import { FETCH_DESTINATIONS } from "@/core/services/store/destinations.module";
import { FETCH_PROGRAMS } from "@/core/services/store/programs.module";
import { GET_DIRECTORY_SIZE } from "@/core/services/store/files.module";
import { FETCH_TRANSACTIONS } from "@/core/services/store/transactions.module";
import {
  FETCH_BANNERS,
  FETCH_BANNER
} from "@/core/services/store/banners.module";
import { mapGetters } from "vuex";
// import VueIdentifyNetwork from "./VueIdentifyNetwork.vue";

export default {
  name: "dashboard",
  components: {
    CountInfo,
    DestinationsWidget,
    ProgramsWidget,
    DownloadAppsWidget,
    ActiveLives
    // VueIdentifyNetwork
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      destinationsLoaded: false,
      programsLoaded: false,
      sizeLoaded: true,
      transactionsLoaded: false,
      videoSrc:
        "https://www.aparat.com/embed/FDH7G?data[rnddiv]=5900863306&data[responsive]=yes&data[title]=" +
        "%D8%A2%D9%85%D9%88%D8%B2%D8%B4%20%D9%BE%D8%AE%D8%B4%20%D8%B2%D9%86%D8%AF%D9%87%20%D8%A8%D8%A7%20%D9" +
        "%BE%D9%84%D8%AA%D9%81%D8%B1%D9%85%20%D9%85%DB%8C%D8%B1%D9%88%D9%84%20%D8%AF%D8%B1%20%D8%A7%DB%8C%D9%" +
        "86%D8%B3%D8%AA%D8%A7%DA%AF%D8%B1%D8%A7%D9%85%20%D9%88%20%D8%A2%D9%BE%D8%A7%D8%B1%D8%A7%D8%AA&&recom=self",
      bannersList: {}
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "داشبورد" }]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getDestinations();
    this.getPrograms();
    // this.getFilesSize();
    this.getTransactions();
    this.getBanners();
  },
  computed: {
    ...mapGetters([
      "destinations",
      "destinationsPagination",
      "programs",
      "programsPagination",
      "directorySize",
      "transactionsPagination",
      "activeLives",
      "banners"
    ]),
    infoComps() {
      return [
        {
          title: this.destinationsPagination.total.toString(),
          loaded: this.destinationsLoaded,
          subtitle: "مقصد‌ها",
          bodyClass: "bg-primary",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.programsPagination.total.toString(),
          loaded: this.programsLoaded,
          subtitle: "برنامه‌‌ها",
          bodyClass: "bg-success",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.transactionsPagination.total.toString(),
          loaded: this.transactionsLoaded,
          subtitle: "تراکنش‌ها",
          bodyClass: "bg-secondary font-family-base",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.bytesToGig(this.directorySize).toFixed(2),
          loaded: this.sizeLoaded,
          subtitle: "فایل‌ها (گیگ)",
          bodyClass: "bg-warning",
          titleClass: "text-white",
          subtitleClass: "text-white"
        }
      ];
    }
  },
  methods: {
    getDestinations() {
      this.destinationsLoaded = false;

      this.$store
        .dispatch(FETCH_DESTINATIONS, {
          editable: true
        })
        .then(() => {
          this.destinationsLoaded = true;
        })
        .catch(() => {
          this.destinationsLoaded = true;
        });
    },
    getPrograms() {
      this.programsLoaded = false;

      this.$store
        .dispatch(FETCH_PROGRAMS, { page: 1 })
        .then(() => {
          this.programsLoaded = true;
        })
        .catch(() => {
          this.programsLoaded = true;
        });
    },
    getFilesSize() {
      this.sizeLoaded = false;

      this.$store
        .dispatch(GET_DIRECTORY_SIZE)
        .then(() => {
          this.sizeLoaded = true;
        })
        .catch(() => {
          this.sizeLoaded = true;
        });
    },
    getTransactions() {
      this.transactionsLoaded = false;

      this.$store
        .dispatch(FETCH_TRANSACTIONS)
        .then(() => {
          this.transactionsLoaded = true;
        })
        .catch(() => {
          this.transactionsLoaded = true;
        });
    },
    getBanners() {
      this.$store
        .dispatch(FETCH_BANNERS)
        .then(data => {
          for (let i in data) {
            let id = data[i].id;
            if (data[i].type !== 4) {
              this.$store
                .dispatch(FETCH_BANNER, id)
                .then(data => {
                  this.bannersList[id] = data;
                })
                .catch(() => {});
            }
          }
        })
        .catch(() => {});
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  }
};
</script>
<style>
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000000' width='8' height='8'%3E%3Cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3E%3C/svg%3E") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000000' width='8' height='8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3E%3C/svg%3E") !important;
}
</style>
